import draftToHtml from "draftjs-to-html";

interface DraftJSEntity {
	type: "LINK" | "IMAGE";
	mutability: "MUTABLE" | "IMMUTABLE";
	data: Record<string, unknown>;
}

type DraftInlineStyleType = "BOLD" | "CODE" | "ITALIC" | "STRIKETHROUGH" | "UNDERLINE";

interface DraftJSBlock {
	key: string;
	text: string;
	type: string;
	depth: number;
	inlineStyleRanges: Array<{
		style: DraftInlineStyleType;
		offset: number;
		length: number;
	}>;
	entityRanges: Array<{
		key: number;
		offset: number;
		length: number;
	}>;
	data?: Record<string, unknown>;
}

interface DraftJSContent {
	blocks: DraftJSBlock[];
	entityMap: Record<string, DraftJSEntity>;
}

export function convertDraftJSToHtml(content: DraftJSContent): string {
	if (!content || !content.blocks) {
		return "";
	}

	return draftToHtml(content);
}
